import React, { ReactElement } from "react";
import { Box, Button } from "@mui/material";

interface Props {
  onClick?: any;
  children: any;
  isGreen?: any;
  disable?: boolean;
  primary?: boolean;
}

export default function CommonButtonDefault({
  onClick,
  children,
  isGreen = false,
  disable = false,
  primary,
}: Props): ReactElement {
  return (
    <Box component="span" mr={2} mb={1}>
      <Button
        color={primary ? "primary" : isGreen ? "secondary" : "inherit"}
        size="small"
        component="label"
        onClick={onClick}
        disabled={disable}
        disableElevation
      >
        {children}
      </Button>
    </Box>
  );
}
